export default {
  next: "Next",
  prev: "Previous"
};
